/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copied_Error_SuccessInputs */

const en_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied!`)
};

const id_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disalin!`)
};

const ms_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disalin!`)
};

const ca_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiat!`)
};

const cs_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkopírováno!`)
};

const da_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieret!`)
};

const de_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiert!`)
};

const et_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopeeritud!`)
};

const es_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Copiado!`)
};

const fr_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copié`)
};

const hr_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopirano!`)
};

const it_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiato!`)
};

const lv_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nokopēts!`)
};

const lt_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nukopijuota!`)
};

const hu_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kimásolva!`)
};

const nl_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gekopieerd.`)
};

const nb_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiert!`)
};

const pl_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skopiowano!`)
};

const pt_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado!`)
};

const ro_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiat!`)
};

const sk_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skopírované!`)
};

const sl_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopirano!`)
};

const fi_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopioitu`)
};

const sv_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopierat!`)
};

const vi_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã sao chép!`)
};

const tr_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopyalandı!`)
};

const el_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έγινε αντιγραφή!`)
};

const bg_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копирано!`)
};

const ru_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировано`)
};

const sr_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копирано!`)
};

const uk_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопійовано!`)
};

const ka_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დაკოპირებულია!`)
};

const hi_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉपी की गई!`)
};

const th_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัดลอกแล้ว!`)
};

const ko_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`복사되었습니다.`)
};

const zh_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已复制！`)
};

const zh_tw_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已複製！`)
};

const ja_copied_error_success = /** @type {(inputs: Copied_Error_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーしました！`)
};

/**
* | output |
* | --- |
* | "Copied!" |
*
* @param {Copied_Error_SuccessInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const copied_error_success = /** @type {((inputs?: Copied_Error_SuccessInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copied_Error_SuccessInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_copied_error_success(inputs)
	if (locale === "ms") return ms_copied_error_success(inputs)
	if (locale === "ca") return ca_copied_error_success(inputs)
	if (locale === "cs") return cs_copied_error_success(inputs)
	if (locale === "da") return da_copied_error_success(inputs)
	if (locale === "de") return de_copied_error_success(inputs)
	if (locale === "et") return et_copied_error_success(inputs)
	if (locale === "es") return es_copied_error_success(inputs)
	if (locale === "fr") return fr_copied_error_success(inputs)
	if (locale === "hr") return hr_copied_error_success(inputs)
	if (locale === "it") return it_copied_error_success(inputs)
	if (locale === "lv") return lv_copied_error_success(inputs)
	if (locale === "lt") return lt_copied_error_success(inputs)
	if (locale === "hu") return hu_copied_error_success(inputs)
	if (locale === "nl") return nl_copied_error_success(inputs)
	if (locale === "nb") return nb_copied_error_success(inputs)
	if (locale === "pl") return pl_copied_error_success(inputs)
	if (locale === "pt") return pt_copied_error_success(inputs)
	if (locale === "ro") return ro_copied_error_success(inputs)
	if (locale === "sk") return sk_copied_error_success(inputs)
	if (locale === "sl") return sl_copied_error_success(inputs)
	if (locale === "fi") return fi_copied_error_success(inputs)
	if (locale === "sv") return sv_copied_error_success(inputs)
	if (locale === "vi") return vi_copied_error_success(inputs)
	if (locale === "tr") return tr_copied_error_success(inputs)
	if (locale === "el") return el_copied_error_success(inputs)
	if (locale === "bg") return bg_copied_error_success(inputs)
	if (locale === "ru") return ru_copied_error_success(inputs)
	if (locale === "sr") return sr_copied_error_success(inputs)
	if (locale === "uk") return uk_copied_error_success(inputs)
	if (locale === "ka") return ka_copied_error_success(inputs)
	if (locale === "hi") return hi_copied_error_success(inputs)
	if (locale === "th") return th_copied_error_success(inputs)
	if (locale === "ko") return ko_copied_error_success(inputs)
	if (locale === "zh") return zh_copied_error_success(inputs)
	if (locale === "zh-tw") return zh_tw_copied_error_success(inputs)
	if (locale === "ja") return ja_copied_error_success(inputs)
	return en_copied_error_success(inputs)
});